import constants from './constants';

Conditions.prototype = [];

Conditions.prototype.toQuery = function(headers, pagination, isURI) {
    let params = {};
    let ignore_project = false;

    if (pagination && !isURI) {
        if (pagination.getOffset) params.offset = pagination.getOffset();
        params.limit = pagination.pageSize;
    }

    if (headers.some((h) => h.sort !== 0) && !isURI) {
        params.ordering = headers.filter(function(f) {
            return f.sort !== 0 && f.serverKey;
        }).map(function(f) {
            return (f.sort === -1 ? "-" : "") + f.serverKey;
        }).reduce(function(a,b) {
            return a + ',' + b;
        });
    }

    this.filter((c) => c.value).forEach(function(c) {
        if (c.key === 'ordering' || c.key === 'search') return;

        if (c.key === 'verified' && !isURI) {
            params['status'] = [constants.STATUS.FINALIZED.value, constants.STATUS.UNABLE_TO_ENRICH.value];
            return;
        }

        var key, value = c.value;
        var header = headers.filter((h) => h.key === c.key)[0];

        key = (isURI ? (header || {}).key : (header || {}).serverKey) || c.key;

        if (!header || header.system || isURI || c.exact) {
            if (key.charAt(0) === ":") key = key.slice(1, key.length);
            key = isURI ? key : c.keyOverride || key;
            params[key] = params[key] || [];
            params[key].push(value);
            return;
        }

        if (!params.search) params.search = [];
        if (params.search.some((p) => p === key + "=" + value)) return; // Avoid duplicates
        // `+` and `;` are symbols that won't be encoded by default but django requires them encoded like this.
        // We can't use here encodeURIComponent because as a result it will be encoded twice.
        if (value) value = value.replace(/\+/g, '%2B').replace(/;/g, '%3B');
        params.search.push(key + "=" + value);
    });

    if (!isURI && ignore_project) {
        delete params.project;
    }

    return isURI ? params : queryString.stringify(params);
};

Conditions.prototype.removeByKey = function(key) {
    this.filter(function(c) {
        return c.key === key;
    }).forEach((c) => {
        var index = this.indexOf(c);
        if (index > -1) this.splice(index, 1);
    });
};

Conditions.prototype.removeByCondition = function(condition) {
    if (!condition) return;
    var index = this.indexOf(condition);
    if (index > -1) this.splice(index, 1);
};

Conditions.prototype.removeConditionByValue = function(condition) {
    var match = this.filter((c) => c.key === condition.key && c.value === condition.value)[0];
    Conditions.prototype.removeByCondition.call(this, match);
};

// Do any type of condition functionality restoration when processing
// a vanilla key/value object with conditions.
Conditions.prototype.constructFromObject = function(object) {
    var conditions = [], key, exact;

    for (key in object) {
        if (key === "ordering") continue;
        exact = key.endsWith('.exact');
        const serverKey = exact ? key.slice(0, key.length - '.exact'.length) : key;

        if (Array.isArray(object[key])) {
            object[key].forEach((v) => conditions.push({
                key: serverKey,
                value: v,
                exact: exact
            }));

            continue;
        }

        conditions.push({
            key: serverKey,
            value: object[key],
            exact: exact
        });
    }

    return conditions;
};

function Conditions(opts) {
    opts = opts || {};
    Object.assign(this, opts);
}

export default Conditions;
